<div id="home-header">
  <div class="header">
    <span class="title">{{ 'doktar_app.home.title' | translate }}</span>
    <span class="subtitle">{{ 'doktar_app.home.main_title' | translate }}</span>
  </div>
  <div class="enterprise-selection-container">
    <div class="enterprise-selection">
      <span class="header-title">{{ 'doktar_app.home.selected_enterprise' | translate }}</span>
      <p-select
        #enterpriseSelect="ngModel"
        [options]="userEnterprises"
        [(ngModel)]="selectedEnterprise"
        optionLabel="name"
        (onChange)="onSelectEnterpriseChange($event.value)"
        [loading]="loadingEnterprises">
        <ng-template #selectedItem let-selectedOption>
          <div class="selected-enterprise">
            <div class="enterprise-name-w-icon">
              <i class="ph-fill ph-handshake"></i>
              <span>{{ selectedOption.name }}</span>
            </div>
          </div>
        </ng-template>
      </p-select>
    </div>
  </div>
</div>
